import { atom } from "recoil";

export const JobTitleAtom = atom({
  key: "jobTitle",
  default: [],
});